import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AnimateOnScrollDirective } from './directives/animate-on-scroll.directive';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AnimateOnScrollDirective],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('EnClaro');
}
